// ADD API URLS BELOW
export const API_URLS = {
    ARTICLE_LIST: '/umbraco/api/articlesApi/getarticles',
    BLOG_LIST: '/umbraco/api/blogApi/getblogs',
    SEARCH_RESULTS_LIST: '/umbraco/api/searchapi/search',
    SEMINARS_LIST: '/umbraco/api/seminarsapi/getseminars',
    STUDENT_SUCCESS_LIST: '/umbraco/api/successstoryapi/getstudentsuccessvideos',
    COURSES_LIST: '/umbraco/api/coursesapi/getcourses',
    LOG_IN: '/umbraco/api/loginapi/login',
    NEWSLETTER_SIGNUP: '/umbraco/api/newslettersapi/signup',
    FORM_RECAPTCHA: '/umbraco/api/forms/validaterecaptcha',
};
